/// <amd-module name="Feed/CreateFeed/Services/IdentityDataService" />
import { IIdentitiesRestClient } from "VSS/Features/Identities/RestClient/Identities";
import { IVssRestClientOptions, IVssService, Services, VssService } from "VSS/Platform/Context";
import { Identity } from "VSS/Platform/Contracts/Identities";

const SpsServiceInstanceType = "951917ac-a960-4999-8464-e3f0aa25b381";

export interface IFeedIdentityDataService extends IVssService {
    listGroups(projectId: string): Promise<Identity[]>;
}

export class IdentityDataService extends VssService {
    private identityRestClient: IIdentitiesRestClient;

    public listGroups(projectId: string): Promise<Identity[]> {
        return this.httpClient.listGroups(projectId);
    }

    private get httpClient(): IIdentitiesRestClient {
        if (!this.identityRestClient) {
            this.identityRestClient = this.pageContext.getRestClient<IIdentitiesRestClient>("IIdentitiesRestClient", {
                serviceInstanceType: SpsServiceInstanceType
            } as IVssRestClientOptions);
        }
        return this.identityRestClient;
    }
}

Services.add("IFeedIdentityDataService", { serviceFactory: IdentityDataService });
